module.exports = __webpack_public_path__ + "static/media/resultados_sobre_pobreza_1.86af0d44.png";